import { render, staticRenderFns } from "./FooterManager.vue?vue&type=template&id=99024e72&scoped=true&"
import script from "./FooterManager.vue?vue&type=script&lang=js&"
export * from "./FooterManager.vue?vue&type=script&lang=js&"
import style0 from "./FooterManager.vue?vue&type=style&index=0&id=99024e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99024e72",
  null
  
)

export default component.exports